'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchInvoiceIfNeeded = exports.isInvoiceLoading = exports.isInvoiceLoaded = exports.getLoadTimeForInvoice = exports.getInvoice = exports.LOAD_INVOICE_SUCCESS = exports.LOAD_INVOICE_REQUEST = exports.LOAD_INVOICE_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _user = require('../modules/user');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_INVOICE_FAIL = exports.LOAD_INVOICE_FAIL = 'la/ui/checkout/LOAD_FAIL';
var LOAD_INVOICE_REQUEST = exports.LOAD_INVOICE_REQUEST = 'la/ui/checkout/LOAD_REQUEST';
var LOAD_INVOICE_SUCCESS = exports.LOAD_INVOICE_SUCCESS = 'la/ui/checkout/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_INVOICE_FAIL:
            return (0, _extends4.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case LOAD_INVOICE_REQUEST:
            return (0, _extends4.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_INVOICE_SUCCESS:
            time = action.meta.actionTime;
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends4.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.catalogId, time));
            loading = (0, _cloneDeep2.default)(state.loading);

            existing[action.meta.catalogId] = action.payload;
            loading = (0, _difference2.default)(loading, [action.meta.catalogId]);
            return (0, _extends4.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.checkout;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getInvoice = exports.getInvoice = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || { invoice: {}, items: [] };
});

var getLoadTimeForInvoice = exports.getLoadTimeForInvoice = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});
var isInvoiceLoaded = exports.isInvoiceLoaded = getLoadTimeForInvoice;
var isInvoiceLoading = exports.isInvoiceLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchInvoice = (0, _reselect.createSelector)([idSelector, getInvoice, getLoadTimeForInvoice, isInvoiceLoading], function (catalogId, invoice, loaded, loading) {
    if (!catalogId) return false;
    if (!(0, _isEmpty2.default)(invoice)) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchInvoiceIfNeeded = exports.fetchInvoiceIfNeeded = function fetchInvoiceIfNeeded(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, bidderId, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchInvoice(state, catalogId)) {
                                _context.next = 18;
                                break;
                            }

                            _context.prev = 2;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            bidderId = (0, _user.getBidderId)(state);

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: LOAD_INVOICE_REQUEST
                            });
                            _context.next = 9;
                            return _api.Checkout.fetchInvoice({ authToken: authToken, bidderId: bidderId, catalogId: catalogId, deployment: deployment });

                        case 9:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: response.data,
                                type: LOAD_INVOICE_SUCCESS
                            });
                            _context.next = 16;
                            break;

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](2);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_INVOICE_FAIL
                            });

                        case 16:
                            _context.next = 19;
                            break;

                        case 18:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 19:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[2, 13]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/checkout.js
// module id = Ng+f
// module chunks = 57